import React from 'react';
import DatePicker from 'react-datepicker';
import "./component-styles.css";

const DateRangePicker = ({
  selectedStartDate,
  selectedEndDate,
  onDateChange,
  maxDate,
  className,
  inputProps,
  isDisabled = false,
}) => {
  const handleDateChange = (dates) => {
    const [start, end] = dates;
    onDateChange(start, end);
  };

  return (
    <div className="relative customDatePickerWidth" >
      <DatePicker
        selected={selectedStartDate}
        onChange={handleDateChange}
        startDate={selectedStartDate}
        endDate={selectedEndDate}
        maxDate={maxDate}
        selectsRange
        placeholderText="Select date range"
        className={className}
        inputProps={inputProps}
        showIcon
        isClearable
        disabled={isDisabled}
      />
    </div>
  );
};

export default DateRangePicker;
